const widowPreventerRegex = /\s(?=[^\s]*$)/g;

export const preventWidows = (s: string) => s.replace(widowPreventerRegex, '\u00A0');